<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="800" draggable>
            <div class="userAdd_man">
                    <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-form-item :label="t('taskSpecial.members')" prop="user_id">
                        <el-select :placeholder="t('common.pleaseSelect')" v-model="state.form.user_id" filterable multiple clearable  popper-class="custom-header">
                            <template #header>
                                <el-checkbox
                                    v-model="checkAll"
                                    :indeterminate="indeterminate"
                                    @change="handleCheckAll"
                                >
                                    {{ t('common.all') }}
                                </el-checkbox>
                                </template>
                            <el-option
                                v-for="(d, i) in state.userList"
                                :key="i"
                                :label="d.real_name"
                                :value="d.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { setMemberApi } from "@/api/improve/improve";
import { usePageI18n } from "@/composables/usePageI18n.js";

const applyLabels = () => {};
const { t } = usePageI18n(applyLabels);

const indeterminate = ref(false)
const checkAll = ref(false)
const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "反馈回复",
    },
    row: {
        type: Object,
        default: () => { },
    }
});

const rules = reactive({
    // username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    // real_name: [{ required: true, message: "请输入手机", trigger: "blur" }],
});

const handleCheckAll = ( ) => {
  
    if(indeterminate.value){
        indeterminate.value = false
        state.userList.map(function(element) {
            state.form.user_id=[]
        });
    }else{
        indeterminate.value = true
        state.userList.map(function(element) {
            state.form.user_id.push(element.id)
        });
    }
  console.log(indeterminate.value)
    
}


const state = reactive({
    dialogVisible: false,
    userList: [],
    form: {
        "task_id": 0,
        "user_id": []
    }
});

const getDetailInfo = (row = {}) => {
    if(row?.id) {
        state.form.task_id = row.id
    } else {
        state.form.task_id = 0
    }
}

const getUserList = () => {
    const requestParams = {
        "keywords": "",
        "role_id": 0,
        "page": 1,
        "limit": 9999
    }
    userListApi(JSON.stringify(requestParams)).then(res => {
      state.userList = res?.data ?? []
    })
}

const open = (row) => {
    state.dialogVisible = true;
    getUserList()
    getDetailInfo(row)
};

const ruleForm = ref(null)
const submit = () => {
    // console.log(state.form)
    ruleForm.value.validate((valid) => {
        if (valid) {
            setMemberApi(JSON.stringify(state.form)).then(res => {
                if(res?.code === 200) {
                    ElMessage.success(t('improveDetail.opSuccess'))
                    state.dialogVisible = false
                    state.form = {
                        "task_id": 0,
                        "user_id": []
                    }
                    emit('refresh')
                } else{
                    ElMessage.error(res?.msg)
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
    try {
        if(row?.id) {
            getTemplateInfo();
        } else {
            form.id = 0
        }
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: grid;
    gap: 20px;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
</style>
